<template>
    <div>
        <div class="margin-left-15">SKU：{{detaildatas.sku}} 仓库：{{detaildatas.orgWarehouseCode}} 库存类型：{{detaildatas.inventoryType== '0' ? '正常库存' : '不可售库存'}}</div>
        <compTablelist v-if="detaildatas.chosetype=='yuliu'" class="margin-layout" :columns="yuliucolumns" v-bind="getYuLiuProps"></compTablelist>
        <compTablelist v-if="detaildatas.chosetype=='zaitu'" class="margin-layout" :columns="zaitucolumns" v-bind="getZaiTuProps"></compTablelist>
    </div>
</template>
<script>
import { HttpGetInventoryReserve, HttpGetInventoryTransport, HttpGetProduct } from '@/service/inventory';
import { mapGetters } from 'vuex';
import mixin from "../mixin.js";

export default {
    mixins: [mixin],
    props:['detaildatas','isAdminnum'],
    data(){
        return {
            formData:{},
            products:[],
        }
    },
    components: {
        compWrapper: () => import("@components/templates/wrapper"),
		// compFormQuery: () => import("@components/templates/formquery"),
        compTablelist: () => import("@components/templates/tablelist"),
	},
    created(){
        this.getDetail()
    },
    computed:{
        ...mapGetters('dictionary', ['getProductList','getSelfmanageorgList', 'getBillcusorgList', 'getCusproductList', 'getSystemWareList', 'getWarehouseAllList','getBillcusWareList','getManageAccountList','getOrgAccountList']),
        getYuLiuProps() {
			return {
				initFormData:{
                    'search[IN_warehouseId]': this.isAdminnum ? this.detaildatas.warehouseId : null,
					'search[IN_orgWarehouseId]': !this.isAdminnum ? this.detaildatas.orgWarehouseId : null,
                    'search[RCN_sku]': this.detaildatas.sku,
                    'search[EQ_inventoryType]': this.detaildatas.inventoryType,
                    'state':this.isAdminnum ? '1' : '0',
                    'search[EQ_pairStatus]':0,
				},
				startUp:true,
				ajaxRequest: HttpGetInventoryReserve,
			};
		},
        getZaiTuProps(){
            return {
				initFormData:{
                    'search[IN_warehouseId]': this.isAdminnum ? this.detaildatas.warehouseId : null,
					'search[IN_orgWarehouseId]': !this.isAdminnum ? this.detaildatas.orgWarehouseId : null,
                    'search[RCN_sku]': this.detaildatas.sku,
                    'search[EQ_inventoryType]': this.detaildatas.inventoryType,
                    'state':this.isAdminnum ? '1' : '0',
                    'search[EQ_pairStatus]':0,
				},
				startUp:true,
				ajaxRequest: HttpGetInventoryTransport,
			};
        },
        yuliucolumns() {
            return [
                {
                    title: this.$t('fbb.warehouse.sequence', { defaultValue: '序号' }),
                    key: 'id',
                    maxWidth: 200,
                },
                {
                    title: this.$t('fbb.alloment.client_organization', { defaultValue: '客户' }),
                    key: 'organizationId',
                    width: this.isAdminnum ? 100 : 0,
                     render: (h, { row }) => {
                        let orgName = this.getSelfmanageorgList.filter(item => {
                            return item.value === row.organizationId
                        })[0] || {}
                        return orgName.label
                    }
                },
                {
                    title: this.$t('erp.b2c.product_orgwarehouse', { defaultValue: '仓库' }),
                    maxWidth: 200,
                    render: (h, { row }) => {
                        let orgWarehouseCode = row.orgWarehouseCode
                        const { label } = (this.isAdminnum ? this.getSystemWareList : this.getWarehouseAllList).find(function (item) {
                            return item.attach.code == orgWarehouseCode
                        }) || {};
                        return <div>{label}</div>
                    }
                },
                {
                    title: this.$t('global.common.project', { defaultValue: '项目' }),
                    render: (h, { row }) =>
                        this.findRenderLabel(
                            this.isAdminnum ? this.getCusproductList : this.getProductList,
                            row.groupCode
                        )
                },
                {
                    title: this.$t('bi.work.task_account_id', { defaultValue: '渠道' }),
                    key: 'sourceChannel',
                },
                {
                    title: 'SKU',
                    key: 'sku',
                },
                {
                    title: this.$t('fbb.inbound.inventory_type', { defaultValue: '库存类型' }),
                    maxWidth: 80,
                    render: (h, { row }) => {
                        let inventoryType = row.inventoryType
                        const { label } = this.getInventoryType.find(function (item) {
                            return item.value == inventoryType
                        }) || {};
                        return <div>{label}</div>
                    }
                },
                {
                    title: this.$t('fbb.alloment.order_type', { defaultValue: '单据类型' }),
                    maxWidth: 80,
                    render: (h, { row }) => {
                        let srcLabel = row.srcLabel
                        const { label } = this.getInventoryReserveSrcLabel.find(function (item) {
                            return item.value == srcLabel
                        }) || {};
                        return <div>{label}</div>
                    }
                },
                {
                    title: this.$t('fbb.headlogistics.associated_number', { defaultValue: '来源单号' }),
                    key: 'sourceNo',
                },
                {
                    title: this.$t('fbb.inventory.keep_number', { defaultValue: '预留数量' }),
                    key: 'quantity',
                    sortable: true
                },
                {
                    title: `${this.$t('fbb.accountmanage.material_size_length', { defaultValue: '长' })}*${this.$t('fbb.accountmanage.material_size_width', { defaultValue: '宽' })}*${this.$t('fbb.accountmanage.material_size_height', { defaultValue: '高' })}(cm)`,
                    key: 'weight',
                    render: (h, { row }) => {
                        var product = this.products.filter(
                            item => {
                              return item.id == row.productId;
                            }
                          )[0]
                          if(product){
                            var Length = product.length;
                            var Width =  product.width;
                            var Height =  product.height;
                            return <div>{Length}*{Width}*{Height}</div>
                          }
                       
                    }
                },
                {
                    title: this.$t('global.common.weight(g)', { defaultValue: '重量(g)' }),
                    key: 'weight',
                    render: (h, { row }) => {
                        var product = this.products.filter(
                            item => {
                              return item.id == row.productId;
                            }
                          )[0]
                          if(product){
                            var weight2 = product.weight
                            return <div>{weight2}</div>
                          }
                        
                        
                    }
                },
                {
                    title: this.$t('global.common.updatedAt', { defaultValue: '更新时间' }),
                    width: 150,
                    render: (h, { row }) => {
                        return <div>{row.updatedAt || '--'}</div>
                    }
                },
            ];
        },
        zaitucolumns() {
            return [
                {
                    title: this.$t('fbb.alloment.client_organization', { defaultValue: '客户' }),
                    key: 'organizationId',
                    width: this.isAdminnum ? 100 : 0,
                    render: (h, { row }) => {
                        let orgName = this.getSelfmanageorgList.filter(item => {
                            return item.value === row.organizationId
                        })[0] || {}
                        return orgName.label
                    }
                },
                {
                    title: this.$t('erp.b2c.product_orgwarehouse', { defaultValue: '仓库' }),
                    maxWidth: 200,
                    render: (h, { row }) => {
                        let orgWarehouseCode = row.orgWarehouseCode
                        const { label } = (this.isAdminnum ? this.getSystemWareList : this.getWarehouseAllList).find(function (item) {
                            return item.attach.code == orgWarehouseCode
                        }) || {};
                        return <div>{label}</div>
                    }
                },
                {
                    title: this.$t('bi.work.task_account_id', { defaultValue: '渠道' }),
                    key: 'sourceChannel',
                },
                {
                    title: this.$t('bi.work.task_line_id', { defaultValue: '项目' }),
                    render: (h, { row }) =>
                        this.findRenderLabel(
                            this.isAdminnum ? this.getCusproductList : this.getProductList,
                            row.groupCode
                        )
                },
                {
                    title: 'SKU',
                    key: 'sku',
                },
                {
                    title: this.$t('fbb.inbound.inventory_type', { defaultValue: '库存类型' }),
                    maxWidth: 80,
                    render: (h, { row }) => {
                        let inventoryType = row.inventoryType
                        const { label } = this.getInventoryType.find(function (item) {
                            return item.value == inventoryType
                        }) || {};
                        return <div>{label}</div>
                    }
                },
                {
                    title: this.$t('fbb.alloment.order_type', { defaultValue: '单据类型' }),
                    key: 'srcLabel',
                    maxWidth: 80,
                    render: (h, { row }) => {
                        let srcLabel = row.srcLabel
                        const { label } = this.getInventoryTransportSrcLabel.find(function (item) {
                            return item.value == srcLabel
                        }) || {};
                        return <div>{label}</div>
                    }
                },
                {
                    title: this.$t('fbb.headlogistics.associated_number', { defaultValue: '来源单号' }),
                    key: 'devNo',
                },
                {
                    title: this.$t('fbb.accountmanage.amount', { defaultValue: '数量' }),
                    key: 'quantity',
                    sortable: true
                },
                {
                    title: `${this.$t('fbb.accountmanage.material_size_length', { defaultValue: '长' })}*${this.$t('fbb.accountmanage.material_size_width', { defaultValue: '宽' })}*${this.$t('fbb.accountmanage.material_size_height', { defaultValue: '高' })}(cm)`,
                    key: 'weight',
                    render: (h, { row }) => {
                        var product = this.products.filter(
                            item => {
                              return item.id == row.productId;
                            }
                          )[0]
                          if(product){
                            var Length = product.length;
                            var Width =  product.width;
                            var Height =  product.height;
                            return <div>{Length}*{Width}*{Height}</div>
                          }
                       
                    }
                },
                {
                    title: this.$t('global.common.weight(g)', { defaultValue: '重量(g)' }),
                    key: 'weight',
                    render: (h, { row }) => {
                        var product = this.products.filter(
                            item => {
                              return item.id == row.productId;
                            }
                          )[0]
                          if(product){
                            var weight2 = product.weight
                            return <div>{weight2}</div>
                          }
                        
                        
                    }
                },
                {
                    title: this.$t('global.common.updatedAt', { defaultValue: '更新时间' }),
                    width: 150,
                    render: (h, { row }) => {
                        return <div>{row.updatedAt || '--'}</div>
                    }
                },
            ];
        },
    },
    methods:{
        getDetail(){
            let productIds = [];
                productIds.push(this.detaildatas.productId);
            HttpGetProduct({
                contextId: global.SYSID,
                productIds:productIds
                })
                .then(res => {
                    this.products = res.data;
                })
                .catch(err => {
                    this.$VMessage.error(err.message);
            });
        }
    }
}
</script>